module.exports = __webpack_public_path__ + "img/video.ad1b0ce5.png";